import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    // Load authentication state from localStorage on component mount
    useEffect(() => {
        const savedAuth = localStorage.getItem('tradingBotAuth');
        if (savedAuth) {
            try {
                const authData = JSON.parse(savedAuth);
                setCurrentUser(authData.user);
                setIsAuthenticated(true);
                console.log('🔍 Restored authentication from localStorage:', authData);
            } catch (error) {
                console.error('🔍 Error restoring authentication:', error);
                localStorage.removeItem('tradingBotAuth');
            }
        }
    }, []);

    console.log('🔍 App.js - isAuthenticated:', isAuthenticated);
    console.log('🔍 App.js - currentUser:', currentUser);

    const handleLogin = (userSession) => {
        console.log('🔍 Login successful:', userSession);
        setCurrentUser(userSession);
        setIsAuthenticated(true);
        
        // Save authentication state to localStorage
        const authData = {
            user: userSession,
            timestamp: new Date().toISOString()
        };
        localStorage.setItem('tradingBotAuth', JSON.stringify(authData));
        console.log('🔍 Saved authentication to localStorage');
    };

    const handleLogout = () => {
        setCurrentUser(null);
        setIsAuthenticated(false);
        
        // Clear authentication state from localStorage
        localStorage.removeItem('tradingBotAuth');
        console.log('🔍 Cleared authentication from localStorage');
    };

    // Show login if not authenticated
    if (!isAuthenticated) {
        console.log('🔍 Rendering Login component');
        return <Login onLogin={handleLogin} />;
    }

    // Show main dashboard
    console.log('🔍 Rendering main dashboard');
    return (
        <div className="App">
            {/* Header with user info and logout */}
            <div className="app-header">
                <div className="user-info">
                    <span>👤 {currentUser?.name || 'User'}</span>
                    <span className="user-role">({currentUser?.role || 'family'})</span>
                </div>
                <button className="logout-btn" onClick={handleLogout}>
                    🚪 Logout
                </button>
            </div>

            {/* Main Dashboard with Overview, Trading, and Analysis tabs */}
            <Dashboard 
                currentUser={currentUser}
                onLogout={handleLogout}
                onShowRegistration={() => {}}
            />
        </div>
    );
}

export default App; 